import { __assign } from "tslib";
/* No DS :( */
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var ThemeSwitchLight = function (props) {
    var instanceId = instances++;
    return (React.createElement(IconWrap, __assign({ disableDefaultColors: true }, props),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 30" },
            React.createElement("defs", null,
                React.createElement("circle", { id: "ThemeSwitchLight-a-" + instanceId, cx: "15", cy: "15", r: "11" })),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("mask", { id: "ThemeSwitchLight-b-" + instanceId, fill: "#fff" },
                    React.createElement("use", { xlinkHref: "#ThemeSwitchLight-a-" + instanceId })),
                React.createElement("use", { fill: "#EAEAEA", transform: "matrix(1 0 0 -1 0 30)", xlinkHref: "#ThemeSwitchLight-a-" + instanceId }),
                React.createElement("path", { fill: "#22272B", d: "M20.597 17L30.8 25.705l-10.111 2.331.263.241-1.415.024L4.19 31.84 7.879 28.5-1 28.654l12.042-9.483 2.659 2.444-6.524 5.837 1.864-.001L20.597 17z", mask: "url(#ThemeSwitchLight-b-" + instanceId + ")", transform: "matrix(-1 0 0 1 29.8 0)" }),
                React.createElement("circle", { cx: "14.864", cy: "12.5", r: "2.5", fill: "#292F34", mask: "url(#ThemeSwitchLight-b-" + instanceId + ")" }),
                React.createElement("circle", { cx: "15", cy: "15", r: "14", stroke: "transparent", strokeWidth: "2" })))));
};
ThemeSwitchLight.displayName = 'ThemeSwitchLight';
export default ThemeSwitchLight;
//# sourceMappingURL=ThemeSwitchLight.js.map